

















































import Vue from 'vue'

const INTERVAL_MS = 5000

export default Vue.extend({
  name: 'LunchImageCarousel',
  props: {
    images: {
      type: Array,
      default: () => []
    },
    thumb: {
      type: Boolean,
      default: false
    },
    intervalMs: {
      type: Number,
      default: INTERVAL_MS
    }
  },
  data () {
    return {
      activeIndex: 0,
      timer: null as number | null
    }
  },
  computed: {
    urls (): string[] {
      const items = Array.isArray(this.images) ? this.images : []
      return items.map((item: any) => {
        if (!item) return ''
        if (typeof item === 'string') return item
        return item.image || item.url || ''
      }).filter(Boolean)
    }
  },
  watch: {
    urls () {
      this.activeIndex = 0
      this.restart()
    }
  },
  mounted () {
    this.restart()
  },
  beforeDestroy () {
    this.pause()
  },
  methods: {
    goTo (index: number) {
      if (!this.urls.length) return
      this.activeIndex = ((index % this.urls.length) + this.urls.length) % this.urls.length
      this.restart()
    },
    next () {
      this.goTo(this.activeIndex + 1)
    },
    prev () {
      this.goTo(this.activeIndex - 1)
    },
    pause () {
      if (this.timer != null) {
        window.clearInterval(this.timer)
        this.timer = null
      }
    },
    resume () {
      this.restart()
    },
    restart () {
      this.pause()
      if (this.urls.length > 1) {
        this.timer = window.setInterval(() => {
          this.activeIndex = (this.activeIndex + 1) % this.urls.length
        }, this.intervalMs || INTERVAL_MS)
      }
    }
  }
})
